import { useSessionMetadata } from '@/hooks/useSessionMetadata'
import { bool2Human, buildDebugTooltip } from '@/lib/helpers/helperFunctions'

export function useAccountMenuDebugTooltip() {
  const sessionMetadata = useSessionMetadata()

  if (!sessionMetadata) {
    return
  }

  const { currentUser, currentCompanyUser, currentGroup, currentCompany } =
    sessionMetadata

  const tooltip: Record<string, unknown> = {
    'User ID': currentUser.id,
    Email: currentUser.email,
  }

  if (currentCompanyUser) {
    Object.assign(tooltip, {
      'Company user ID': currentCompanyUser.id,
    })
  }

  if (currentCompany) {
    Object.assign(tooltip, {
      'Company ID': currentCompany.id,
      'Company type': currentCompany.companyType.code,
      'Regulated?': bool2Human(currentCompany.isRegulated),
      'ICAEW-regulated?': bool2Human(currentCompany.isRegulatedByIcaew),
    })
  }

  if (currentGroup) {
    Object.assign(tooltip, {
      'Group ID': currentGroup.id,
      'Group companies': `${currentGroup.companies.length} (${currentGroup.companies.map((company) => company.name).join(', ')})`,
    })
  }

  return buildDebugTooltip(tooltip)
}
